

import React, {useState, useReducer, useEffect} from 'react';
import './App.scss';

import data from './data';

import EducationComponent from './EducationComponent';
import SkillsComponent from './SkillsComponent';
import Certifications from './Certifications';
import SocialComponent from './SocialComponent';
import WorkComponent from './WorkComponent';
import PersonalDetailsComponent from './PersonalDetailsComponent';
import ReferencesComponent from './ReferencesComponent';
import 'bootstrap/dist/js/bootstrap.bundle';
import Template1 from './templates/Template1'
import Template2 from './templates/Template2'
import Template3 from './templates/Template3'
import Template4 from './templates/Template4'
import Template5 from './templates/Template5'
import Template6 from './templates/Template6'
import Template7 from './templates/Template7'
import Template8 from './templates/Template8'
import Template9 from './templates/Template9'
import Template10 from './templates/Template10'
import Template11 from './templates/Template11'
import Template12 from './templates/Template12'
import Template13 from './templates/Template13'
import ResumeChatWidget from './ResumeChatWidget';

import Template1Pdf from './templates/pdf/Template1Pdf';
import Template2Pdf from './templates/pdf/Template2Pdf';
import Template3Pdf from './templates/pdf/Template3Pdf';
import Template4Pdf from './templates/pdf/Template4Pdf';
import Template5Pdf from './templates/pdf/Template5Pdf';
import Template6Pdf from './templates/pdf/Template6Pdf';
import Template7Pdf from './templates/pdf/Template7Pdf';
import Template8Pdf from './templates/pdf/Template8Pdf';
import Template9Pdf from './templates/pdf/Template9Pdf';
import Template10Pdf from './templates/pdf/Template10Pdf';
import Template11Pdf from './templates/pdf/Template11Pdf';
import Template12Pdf from './templates/pdf/Template12Pdf';
import Template13Pdf from './templates/pdf/Template13Pdf';

import ATSClassic from './templates/ATSClassic';
import ATSModern from './templates/ATSModern';
import ATSCompact from './templates/ATSCompact';



const PDF_TEMPLATES = {
    template1: Template1Pdf, template2: Template2Pdf, template3: Template3Pdf,
    template4: Template4Pdf, template5: Template5Pdf, template6: Template6Pdf,
    template7: Template7Pdf, template8: Template8Pdf, template9: Template9Pdf,
    template10: Template10Pdf, template11: Template11Pdf, template12: Template12Pdf,
    template13: Template13Pdf,
};


import Header from './Header';
import Footer from './Footer';
import AtsScoreWidget from './AtsScoreWidget';
import PdfDownloadButton from './templates/pdf/PdfDownloadButton';




const resumeData = {
  targetRole: "Frontend Developer",
  experienceLevel: "Senior",
  summary: "I was responsible for building out new customer websites using a custom-built WYSIWYG editor and modifying a pre-built CSS template. I create aesthetically pleasing website designs using my understanding of color theory, and typography. My job is to build websites utilizing our sister company's software and also coding out custom cross-browser compatible web sections, landing pages, and/or alternative templates using HTML5, CSS3, and JavaScript, and/or related languages, frameworks, etc. As a Dumpster Rental Systems developer, I'm responsible for maintaining communication with clients and keeping them informed on the status",
  skills: ["React", "Vue", "JavaScript", "Accessibility"],
  experience: [
    {
      title: "Senior UI Engineer",
      bullets: [
        "Built reusable UI components",
        "Improved Lighthouse score"
      ]
    }
  ]
};

const MAX_TEXT_LENGTH = 2000;

function sanitizeString(input = "") {
  if (typeof input !== "string") return "";

  return input
    // Remove HTML / script tags
    .replace(/<[^>]*>/g, "")
    // Remove control characters
    .replace(/[\u0000-\u001F\u007F]/g, "")
    // Normalize whitespace
    .replace(/\s+/g, " ")
    // Trim
    .trim()
    // Prevent huge payloads
    .slice(0, MAX_TEXT_LENGTH);
}

function sanitizeNumber(input) {
  if (typeof input === "number") return input;
  if (typeof input === "string" && /^\d+$/.test(input)) return input;
  return "";
}

function sanitizeArray(arr = [], mapper = (x) => x) {
  if (!Array.isArray(arr)) return [];
  return arr.map(mapper).filter(Boolean);
}

function sanitizeLabelValueArray(arr = []) {
  return sanitizeArray(arr, (item) =>
    sanitizeString(item?.value || item?.label)
  );
}


const sanitizeAndFormatResume = (raw = {}) => {
  return {
    personal: {
      name: sanitizeString(raw.name),
      title: sanitizeString(raw.title),
      email: sanitizeString(raw.email),
      phone: sanitizeNumber(raw.phone),
      address: sanitizeString(raw.address),
    },

    summary: sanitizeString(raw.about),

    skills: {
      technical: sanitizeLabelValueArray(raw.technicalSkills),
      soft: sanitizeLabelValueArray(raw.softSkills),
      languages: sanitizeLabelValueArray(raw.languages),
    },

    experience: sanitizeArray(raw.jobData, (job) => ({
      company: sanitizeString(job?.jobCompanyName),
      title: sanitizeString(job?.jobTitle),
      location: sanitizeString(job?.jobLocation),
      duration: `${sanitizeString(job?.jobFromDate)} – ${sanitizeString(
        job?.jobToDate
      )}`,
      summary: sanitizeString(job?.jobSummary),
    })),

    education: sanitizeArray(raw.educationData, (edu) => ({
      institution: sanitizeString(edu?.eduUniversity),
      degree: sanitizeString(edu?.eduTitle),
      location: sanitizeString(edu?.eduLocation),
      duration: `${sanitizeString(edu?.eduFromDate)} – ${sanitizeString(
        edu?.eduToDate
      )}`,
      summary: sanitizeString(edu?.eduSummary),
    })),

    social: raw.showSocial
      ? {
          linkedin: sanitizeString(raw.linkedinURL),
          twitter: sanitizeString(raw.twitterURL),
          website: sanitizeString(raw.websiteURL),
        }
      : null,

    references: sanitizeArray(raw.referenceData, (ref) => ({
      name: sanitizeString(ref?.name),
      title: sanitizeString(ref?.title),
      email: sanitizeString(ref?.email),
      phone: sanitizeString(ref?.phone),
    })),

    meta: {
      template: sanitizeString(raw.template),
      font: sanitizeString(raw.selectedFont),
    },
  };
}

function cvReducer(state, action) {
    // console.log(`Action triggered`, action)
    switch(action.type) {
        
        case 'field': {
            localStorage.setItem('mycv', JSON.stringify({
                ...state,
                [action.field]: action.value
            }));
            return {
                ...state,
                [action.field]: action.value
            }
        }
        default: 
            break;
    }

    return state;
}

const initialState = JSON.parse(localStorage.getItem('mycv')) ? JSON.parse(localStorage.getItem('mycv')) : data;

export const TemplateComponent = (state) => {
    const {template, selectedFont} = state;
    switch (template) {
        case 'ats-classic':
            return <div className={`${template} ${selectedFont} shadow-lg bg-white rounded`}><ATSClassic {...state} /></div>;
        case 'ats-modern':
            return <div className={`${template} ${selectedFont} shadow-lg bg-white rounded`}><ATSModern {...state} /></div>;
        case 'ats-compact':
            return <div className={`${template} ${selectedFont} shadow-lg bg-white rounded`}><ATSCompact {...state} /></div>;
        case 'template1':
            return <div className={`${template} ${selectedFont} shadow-lg bg-white rounded`}><Template1 {...state} /></div>;

        case 'template2':
            return <div className={`${template} ${selectedFont} shadow-lg bg-white rounded`}><Template2 {...state} /></div>;
        case 'template3':
            return <div className={`${template} ${selectedFont} shadow-lg bg-white rounded`}><Template3 {...state} /></div>;
        case 'template4':
            return <div className={`${template} ${selectedFont} shadow-lg bg-white rounded`}><Template4 {...state} /></div>;
        case 'template5':
            return <div className={`${template} ${selectedFont} shadow-lg bg-white rounded`}><Template5 {...state} /></div>;
        case 'template6':
            return <div className={`${template} ${selectedFont} shadow-lg bg-white rounded`}><Template6 {...state} /></div>;
        case 'template7':
            return <div className={`${template} ${selectedFont} shadow-lg bg-white rounded`}><Template7 {...state} /></div>;
        case 'template8':
            return <div className={`${template} ${selectedFont} shadow-lg bg-white rounded`}><Template8 {...state} /></div>;
        case 'template9':
            return <div className={`${template} ${selectedFont} shadow-lg bg-white rounded`}><Template9 {...state} /></div>;
        case 'template10':
            return <div className={`${template} ${selectedFont} shadow-lg bg-white rounded`}><Template10 {...state} /></div>;
        case 'template11':
            return <div className={`${template} ${selectedFont} shadow-lg bg-white rounded`}><Template11 {...state} /></div>;
        case 'template12':
            return <div className={`${template} ${selectedFont} shadow-lg bg rounded`}><Template12 {...state} /></div>;
        case 'template13':
            return <div className={`${template} ${selectedFont} shadow-lg bg rounded`}><Template13 {...state} /></div>;
        default:
            return <div className={`${template} ${selectedFont} shadow-lg bg-white rounded`}><Template1 {...state} /></div>;
    }
};

function flattenObjectToString(obj) {
    const result = [];
  
    function extract(value) {
      if (typeof value === 'string' || typeof value === 'number') {
        result.push(String(value).trim());
      } else if (Array.isArray(value)) {
        value.forEach(item => extract(item));
      } else if (typeof value === 'object' && value !== null) {
        Object.values(value).forEach(val => extract(val));
      }
    }
  
    extract(obj);
    return result.filter(Boolean).join(', ');
  }
  
  

const JobDescription = (props) => {
    const [jobDescription, setJobDescription] = useState('')
    const [atsScore, setAtsScore] = useState(0)

    const handleATSScore = async () => {
        const response = await fetch('http://localhost:4000/ats-score', {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              resume: flattenObjectToString(props.resume),
              jobDescription: jobDescription,
            }),
          })
        const json = await response.json()
        setAtsScore(json)
        // console.log(json)
        props.handleATSScore(json)

    }
    return (
        <div style={{textAlign: 'center'}}>
            <textarea text="jobDescription" placeholder='Paste job description to evaluate your resume' className="form-control" id="jobDescription" aria-describedby="job description" rows={15} onChange={(e) => setJobDescription(e.target.value)} />
            <button type="button" className='fs-6 text bg-dark' style={{border: 1, marginTop: 10, borderRadius: 5, color: 'white', padding: 10}} onClick={handleATSScore}>Calculate ATS Score</button>
        </div>
    )
}


function App() { 
    const [state, dispatch] = useReducer(cvReducer, initialState);
    const PdfTemplate = PDF_TEMPLATES[state.template] || Template1Pdf;
    const [score, setScore] = useState(null)
    const [atsScoreBtnClicked, setATSScoreBtnClicked] = useState(false)
    const {
        showSocial
    } = state;

    const handleATSScore = (props) => {
        setScore(Math.round(parseInt(props.keywordScore)))
        setATSScoreBtnClicked(true)
    }

    const handleCheckBoxChange = (event) => {
        const {target} = event;
        const {name, checked} = target;
        dispatch({
            type: 'field',
            field: name,
            value: checked
        })
    }

    // const clearDefaultData = () => {

    // }

    return (
        <div>
            <Header dispatch={dispatch} initialValues={state}/>
            
            <div className={'container'}>        
                <div className="item-1">
                
                <form className='mb-8'>
                    {/* <button type="button" className="btn clear-data">
                        <Icon icon={faTrash} /> {' '}
                        Clear default data
                    </button> */}
                    <div className="accordion" id="resumeAccordion">
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingOne">
                            <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                            <label>Personal Details</label>
                            </button>
                            </h2>
                            <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#resumeAccordion">
                            <div className="accordion-body">
                                <PersonalDetailsComponent dispatch={dispatch} initialValues={state} />
                            </div>
                            </div>
                        </div>
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingTwo">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                Education Details
                            </button>
                            </h2>
                            <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#resumeAccordion">
                            <div className="accordion-body">
                                <EducationComponent dispatch={dispatch} initialValues={state} />
                            </div>
                            </div>
                        </div>
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingThree">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                Skills
                            </button>
                            </h2>
                            <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#resumeAccordion">
                            <div className="accordion-body">
                                <SkillsComponent dispatch={dispatch} initialValues={state} />
                            </div>
                            </div>
                        </div>

                        {/* <div className="accordion-item">
                            <h2 className="accordion-header" id="headingThree">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseCertifications" aria-expanded="false" aria-controls="collapseCertifications">
                                Certifications
                            </button>
                            </h2>
                            <div id="collapseCertifications" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#resumeAccordion">
                            <div className="accordion-body">
                                <Certifications dispatch={dispatch} initialValues={state} />
                            </div>
                            </div>
                        </div> */}

                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingFour">
                            
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                Social
                            </button>
                            </h2>
                            <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#resumeAccordion">
                            <div className="accordion-body">
                                <div className="form-check">
                                    <input type="checkbox" name="showSocial" checked={showSocial} className="form-check-input" id="showSocial" onChange={handleCheckBoxChange} />
                                    <label className="form-check-label" htmlFor="showSocial">{' '} Show in CV</label>
                                </div>
                                <SocialComponent dispatch={dispatch} initialValues={state} />
                            </div>
                            </div>
                        </div>


                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingFive">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                Work Details
                            </button>
                            </h2>
                            <div id="collapseFive" className="accordion-collapse collapse" aria-labelledby="headingFive" data-bs-parent="#resumeAccordion">
                            <div className="accordion-body">
                                <WorkComponent dispatch={dispatch} initialValues={state} />
                            </div>
                            </div>
                        </div>

                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingSix">
                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                                References
                            </button>
                            </h2>
                            <div id="collapseSix" className="accordion-collapse collapse" aria-labelledby="headingSix" data-bs-parent="#resumeAccordion">
                            <div className="accordion-body">
                                <ReferencesComponent dispatch={dispatch} initialValues={state} />
                            </div>
                            </div>
                        </div>
                    </div>   
                </form>
                </div>
                <TemplateComponent {...state} />
                {/* <div>
                    <JobDescription handleATSScore={handleATSScore} resume={state} />
                    <AtsScoreWidget score={score} atsScoreBtnClicked={atsScoreBtnClicked} />
                </div> */}
            
            </div>
            {/* <div style={{ textAlign: 'center', margin: '20px 0' }}>
                <PdfDownloadButton state={state} />
            </div> */}
            <ResumeChatWidget resume={sanitizeAndFormatResume(state)} />
            <Footer />
        </div>
    );
}
export default App;